import { render, staticRenderFns } from "./detailConference.vue?vue&type=template&id=47e601e6"
import script from "./detailConference.vue?vue&type=script&lang=js"
export * from "./detailConference.vue?vue&type=script&lang=js"
import style0 from "./detailConference.vue?vue&type=style&index=0&id=47e601e6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports